import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import store from '@/stores/store-authen'

import VueSweetalert2 from 'vue-sweetalert2'
import VueMasonry from 'vue-masonry-css'

Vue.config.productionTip = false

Vue.use(VueSweetalert2)
Vue.use(VueMasonry)

import "@/scss/main.scss"
import 'sweetalert2/dist/sweetalert2.min.css'

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
